<template>
  <div class="sd-subscription-page sd-report-cbt-subscription">
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard
      </router-link>
      <router-link to="/school/subscription" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i> Subscription
      </router-link>
      <span class="text-white"> <i class="fa fa-ellipsis-v px-2"></i>Report Card and CBT Subscription</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="sd-page-heading">
        <span class="sd-page-eyebrow">REPORT CARD &amp; CBT</span>
        <h1>Manage report card subscriptions</h1>
        <p>Select a session and term to review students and their subscription total.</p>
      </div>
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <div class="row">
            <div class="col-md-4">
              <div class="card sd-filter-panel border-0 mb-0">
                <div class="card-body">
                  <div class="form-horizontal">
                    <div class="card sd-filter-card">
                      <div class="card-body">
                        <div class="form-group">
                          <label for="subscription-session">Session</label>
                          <select id="subscription-session" v-model="SessionIdval" class="form-control" @change="getregterm()">
                            <option value=""></option>
                            <option v-for="item in Sessionitems" :key="item.Id" v-bind:value="item.Id">
                              {{ item.SchSession }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group" v-if="SessionIdval > 0">
                          <label for="subscription-term">Term</label>
                          <select id="subscription-term" v-model="TermIdval" class="form-control"
                            @change="searchstudentforreportcardsubscription()">
                            <option value="0"></option>
                            <option v-for="item in termitems" :key="item.Id" v-bind:value="item.Id">
                              {{ item.SchTerm }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div v-if="TermIdval">
                      <div class="sd-payment-summary" v-if="studentitems">
                        <span class="sd-page-eyebrow">AMOUNT DUE</span>
                        <h2 class="sd-price-value">
                          <span class="badge badge-primary">{{
                            studentitems.TotalAmount
                            }}</span>
                        </h2>
                        <div>
                          <button v-if="hasProcessTransaction == true" class="btn btn-warning m-2"
                            @click="asyncPay">Click here to confirm payment <i class="ivu-icon-md-refresh"></i>
                          </button>

                          <button class="btn btn-info" @click="asyncPay">Click here to make payment <i
                              class="fa fa-arrow-right"></i> </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8" v-if="TermIdval">
              <div class=" input-group">
                <input v-model="searchval" class="form-control" @keyup="searchstudentforreportcardsubscription"
                  placeholder="Search..." />
                <div class=" input-group-append">
                  <button type="button" @click.prevent="searchstudentforreportcardsubscription"
                    class="btn btn-secondary">
                    <i class="fa fa-search"></i> Search
                  </button>
                </div>
              </div>
              <div class="row" v-if="studentitems">
                <div class="col-md-4" v-for="item in studentitems.StudentList" :key="item.Id">
                  <div class="card sd-student-card text-center m-2">
                    <div class="card-body">
                      <img v-if="item.Passport" :src="item.Passport" class="rounded" alt="" height="50" />
                      <img v-else src="img/brand/loguser.png" class="rounded" alt="" height="50" />
                      <h5 class="text-white"><small>{{ item.StudentName }}</small> </h5>
                      <h6 class="text-white"> <small>{{ item.AdmissionNumber }} | {{ item.StudentClass }} </small>
                      </h6>
                      <div>
                        <button class="btn btn-danger btn-sm my-2"
                          v-on:click="deletestudentforreportcardsubscription(item.Id)">
                          <i class="fa fa-times"></i> Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
  name: "reportcarsub",
  mixins: [Alert, CheckStaffUser],
  components: {
    PageSpinner
  },
  data() {
    return {
      accessDetails: null,
      dataid: 1,
      SessionIdval: "",
      TermIdval: "",
      hasProcessTransaction: false,
      Sessionitems: null,
      termitems: null,
      searchval: "",
      studentitems: null,
      paymentItem: null,
      process: "N",
      onloader: "none",
      paymentData: {
        tx_ref: '',
        amount: 0,
        currency: "NGN",
        payment_options: "card,ussd",
        redirect_url: "https://schooldock.com/reportcardandcbtsubscription",
        customer: {
          name: "",
          email: "",
          phone_number: ""
        },
        customizations: {
          title: "SchoolDock",
          description: "Report card subscription",
          logo: "https://schooldock.com/img/brand/favicon.png"
        },
        callback: this.makePaymentCallback,
        onclose: this.closedPaymentModal
      }
    };
  },
  methods: {
    asyncPay() {
      this.asyncPayWithFlutterwave(this.paymentData).then(response => {
        console.log(response);
      });
    },
    makePaymentCallback(response) {
      console.log("Payment callback", response);
    },
    closedPaymentModal() {
      console.log("payment modal is closed");
    },
    generateReference() {
      let date = new Date();
      return date.getTime().toString();
    },
    populatePaymentData(TransRef, Amount, CustomerName, CustomerEmail, CustomerPhoneNo) {
      this.paymentData.tx_ref = TransRef
      this.paymentData.amount = Amount
      this.paymentData.customer.name = CustomerName
      this.paymentData.customer.email = CustomerEmail
      this.paymentData.customer.phone_number = CustomerPhoneNo
    },
    getregsession() {
      this.termitems = null;
      this.SessionIdval = 0;
      this.onloader = "flex";
      this.$store
        .dispatch("getregsession")
        .then((resp) => {
          this.Sessionitems = resp;
          this.onloader = "none";
        })
        .catch((err) => {
          console.log(err);
          this.onloader = "none";
          this.$store.dispatch("logout");
          this.$router.push("/home");
        });
    },
    getregterm() {
      this.TermIdval = 0;
      let SessionId = this.SessionIdval;
      if (SessionId > 0) {
        this.onloader = "flex";
        this.$store
          .dispatch("getregterm", SessionId)
          .then((resp) => {
            this.termitems = resp;
            this.onloader = "none";
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, '');
          });
      }
    },
    searchstudentforreportcardsubscription() {
      let SessionId = this.SessionIdval;
      let TermId = this.TermIdval;
      let SearchItem = this.searchval;
      if (TermId > 0) {
        let userdata = {
          SessionId,
          TermId,
          SearchItem,
        };
        this.onloader = "flex";
        this.$store
          .dispatch("getstudentforreportcardandcbtsubscriptionforpayment", userdata)
          .then((resp) => {
            this.populatePaymentData(resp.TransactionRef, resp.Amount, resp.CustormerName, resp.CustomerEmailAddress, resp.CustormerPhoneNo)
            this.studentitems = resp;
            this.hasProcessTransaction = resp.hasProcessTransaction
          })
          .catch((err) => {
            this.ShowAlertError(err.response && err.response.data || err.message || "Unable to load subscription details.", '');
          })
          .finally(() => {
            this.onloader = "none";
          });
      }
    },
    deletestudentforreportcardsubscription(Id) {
      let SessionId = this.SessionIdval;
      let TermId = this.TermIdval;
      if (TermId > 0) {
        let userdata = {
          SessionId,
          TermId,
          Id,
        };
        this.onloader = "flex";

        this.$store
          .dispatch("deletestudentforreportcardsubscription", userdata)
          .then((resp) => {
            this.populatePaymentData(resp.TransactionRef, resp.Amount, resp.CustormerName, resp.CustomerEmailAddress, resp.CustormerPhoneNo)
            this.studentitems = resp;
            this.onloader = "none";
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, '');
          });
      }
    },
    getpaymentrequest() {
      let tx_ref = this.$route.query.transaction_id;
      if (tx_ref != null || tx_ref != undefined) {
        let status = this.$route.query.status;
        if (status == "successful") {
          this.onloader = "flex";
          this.$store
            .dispatch("processreportcardsubscription", tx_ref)
            .then(() => {
              this.onloader = "none";
              this.ShowAlertSuccess("Submitted successfully", '');
            })
            .catch((err) => {
              this.onloader = "none";
              console.log(err)
            });
        }
      }
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    } else {
      this.getpaymentrequest();
      this.getregsession();
    }

  },
};
</script>

<style></style>
